/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import ImageUpload from "./ImageUpload";
import html2canvas from "html2canvas";

const Block1 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(4).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <div className="large-bg collage-13 images-12-12 s-c-1">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>12"</span> */}
          </div>
          <div id="captureArea">
            <div className="d-flex storyOutline">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/4-images-12-12-1.svg"
                className="images-12-12-1"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/4-images-12-12-2.svg"
                className="images-12-12-1"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/4-images-12-12-3.svg"
                className="images-12-12-1"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
              />
            </div>
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/4-images-12-12-4.svg"
                className="images-12-12-2"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
              />
            </div>
           </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>12"</span> */}
        </div>
      </div>
    </div>
  );
};

const Block2 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(6).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-13 images-12-12 s-c-2">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>20"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/6-images-12-12-4.svg"
                  className="frame-images-12-12-4"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/4-images-12-12-2.svg"
                    className="images-12-12-1"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />

                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/4-images-12-12-3.svg"
                    className="images-12-12-1"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
              </div>
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/4-images-12-12-2.svg"
                  className="images-12-12-1"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                />

                <ImageUpload
                  defaultImage="assets/img/breadcrumb/4-images-12-12-2.svg"
                  className="images-12-12-1"
                  onChange={(e) => {
                    handleImageChange(e, 4);
                  }}
                />

                <ImageUpload
                  defaultImage="assets/img/breadcrumb/4-images-12-12-3.svg"
                  className="images-12-12-1"
                  onChange={(e) => {
                    handleImageChange(e, 5);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>20"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block3 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(9).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <div className="large-bg collage-14 s-c-3">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>20"</span> */}
          </div>
          <div id="captureArea">
          <div className="d-flex align-items-center storyOutline">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
              />

              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 6);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 7);
                }}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/three-images-20x20.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 8);
                }}
              />
            </div>
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>20"</span> */}
        </div>
      </div>
    </div>
  );
};

const Block4 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(4).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-15 images-12-12 s-c-4">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>16"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-16-24-right.svg"
                  className="images-16-24-right"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/6-images-12-12-4.svg"
                  className="frame-images-12-12-4 img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 1);
                  }}
                />
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/4-images-12-12-2.svg"
                    className="images-12-12-1"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/4-images-12-12-3.svg"
                    className="images-12-12-1"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>24"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block5 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(3).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-16 images-12-12 s-c-5">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>16"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-16-24-right.svg"
                  className="images-16-24-right"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-16x24-3w-ri.svg"
                  className="images-16x24-3w-ri img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 1);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-16x24-3w-ri.svg"
                  className="images-16x24-3w-ri img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>24"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block6 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(6).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-17 images-12-12 s-c-6">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>16"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/image-16x24-6w-left.svg"
                  className="image-16x24-6w-left"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/image-16x24-6w-left.svg"
                  className="image-16x24-6w-left"
                  onChange={(e) => {
                    handleImageChange(e, 1);
                  }}
                />
              </div>
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-16x24-6w-right.svg"
                    className="image-16x24-6w-right img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-16x24-6w-right.svg"
                    className="image-16x24-6w-right img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-16x24-6w-right.svg"
                    className="image-16x24-6w-right img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-16x24-6w-right.svg"
                    className="image-16x24-6w-right img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>24"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block7 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(8).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-18 images-12-12 s-c-7">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>16"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-12-12-1-left-bottom.svg"
                  className="images-12-12-1-left-bottom"
                  onChange={(e) => {
                    handleImageChange(e, 6);
                  }}
                />
              </div>
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-12-12-1--right.svg"
                  className="images-12-12-1--right"
                  onChange={(e) => {
                    handleImageChange(e, 7);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>24"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block8 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-19 images-12-12 s-c-8">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x36-5w-top-section.svg"
                  className="f-24x36-5w-top-section"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-5w-bottom-section.svg"
                    className="f-24x36-5w-bottom-section img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-5w-bottom-section.svg"
                    className="f-24x36-5w-bottom-section img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-5w-bottom-section.svg"
                    className="f-24x36-5w-bottom-section img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-5w-bottom-section.svg"
                    className="f-24x36-5w-bottom-section img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block9 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(13).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-20 images-12-12 s-c-9">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 6);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 7);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 8);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 9);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 10);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-24x36-13w.svg"
                    className="images-24x36-13w img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 11);
                    }}
                  />
                </div>
              </div>
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-24x36-13w-right.svg"
                  className="images-24x36-13w-right"
                  onChange={(e) => {
                    handleImageChange(e, 12);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block10 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(8).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-21 images-12-12 s-c-10">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/images-12-12-1-left-top.svg"
                    className="images-12-12-1-left-top img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>

                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-12-12-1-left-bottom.svg"
                  className="images-12-12-1-left-bottom"
                  onChange={(e) => {
                    handleImageChange(e, 6);
                  }}
                />
              </div>
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/images-12-12-1--right.svg"
                  className="images-12-12-1--right"
                  onChange={(e) => {
                    handleImageChange(e, 7);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block11 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(18).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-22 images-12-12 s-c-11">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 6);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 7);
                    }}
                  />
                </div>
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x36-18w-image-right.svg"
                  className="f-24x36-18w-image-right"
                  onChange={(e) => {
                    handleImageChange(e, 8);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x36-18w-image-right.svg"
                  className="f-24x36-18w-image-right"
                  onChange={(e) => {
                    handleImageChange(e, 9);
                  }}
                />
              </div>
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 10);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 11);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 12);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 13);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 14);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 15);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 16);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-24x36-18w-image.svg"
                    className="f-24x36-18w-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 17);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block12 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(4).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-23 images-12-12 s-c-12">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>36"</span> */}
            </div>
            <div  id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/image-36x36-4w-top.svg"
                  className="image-36x36-4w-top"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-36x36-4w-bottom.svg"
                    className="image-36x36-4w-bottom img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-36x36-4w-bottom.svg"
                    className="image-36x36-4w-bottom img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/image-36x36-4w-bottom.svg"
                    className="image-36x36-4w-bottom img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block13 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-24 images-12-12 s-c-13">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>36"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/img-36x36-5w-first-top.svg"
                    className="img-36x36-5w-first-top"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/img-36x36-5w-last-top-right.svg"
                    className="img-36x36-5w-last-top-right"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/img-36x36-5w-first-bottom.svg"
                    className="img-36x36-5w-first-bottom img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/img-36x36-5w-first-bottom.svg"
                    className="img-36x36-5w-first-bottom img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/img-36x36-5w-first-bottom.svg"
                    className="img-36x36-5w-first-bottom img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block14 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(13).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-25 add-more images-12-12 s-c-14">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>36"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                </div>
                <div className="d-flex" id="captureArea">
                  <div className="frame-left">
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                      className="f-36x36-16w-small-image img-16-24"
                      onChange={(e) => {
                        handleImageChange(e, 4);
                      }}
                    />
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                      className="f-36x36-16w-small-image img-16-24"
                      onChange={(e) => {
                        handleImageChange(e, 5);
                      }}
                    />
                  </div>
                  <div className="frame-left">
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-18x48-3w-l-center.svg"
                      className="f-18x48-3w-l-center center-img"
                      onChange={(e) => {
                        handleImageChange(e, 6);
                      }}
                    />
                  </div>
                  <div className="frame-left">
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                      className="f-36x36-16w-small-image img-16-24"
                      onChange={(e) => {
                        handleImageChange(e, 7);
                      }}
                    />
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                      className="f-36x36-16w-small-image img-16-24"
                      onChange={(e) => {
                        handleImageChange(e, 8);
                      }}
                    />
                  </div>
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 9);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 10);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 11);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 12);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block15 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(16).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-25 images-12-12 s-c-15">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>36"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 6);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 7);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 8);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 9);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 10);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 11);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 12);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 13);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 14);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-36x36-16w-small-image.svg"
                    className="f-36x36-16w-small-image img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 15);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>36"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block16 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(9).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-26 images-12-12 s-c-16">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>18"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-9w-left-top.svg"
                  className="f-18x48-9w-left-top"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <div className="d-flex">
                  <div className="image-bottom-left">
                    <div className="d-flex">
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 1);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 2);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 3);
                        }}
                      />
                    </div>
                    <div className="d-flex">
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 4);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 5);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 6);
                        }}
                      />
                    </div>
                  </div>
                  <div className="image-bottom-right">
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom-f.svg"
                      className="f-18x48-9w-small-bottom-f"
                      onChange={(e) => {
                        handleImageChange(e, 7);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-9w-big-str.svg"
                  className="f-18x48-9w-big-str"
                  onChange={(e) => {
                    handleImageChange(e, 8);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>48"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block17 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(3).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-27 images-12-12 s-c-17 d-flex justify-content-center align-items-center">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>18"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-3w-three.svg"
                    className="f-18x48-3w-three img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-3w-three.svg"
                    className="f-18x48-3w-three img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-3w-three.svg"
                    className="f-18x48-3w-three img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>48"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block18 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-28 images-12-12 s-c-18 d-flex justify-content-center align-items-center">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>18"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24 image-align"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24 image-align"
                  onChange={(e) => {
                    handleImageChange(e, 1);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-center.svg"
                  className="f-18x48-3w-l-center"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24 image-align"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24 image-align"
                  onChange={(e) => {
                    handleImageChange(e, 4);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>48"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block19 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(7).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-29 images-12-12 s-c-19 d-flex justify-content-center align-items-center">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>18"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-7w-2.svg"
                  className="f-18x48-3w-l-center"
                  onChange={(e) => {
                    handleImageChange(e, 6);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>48"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block20 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(9).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-30 images-12-12 s-c-20">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-9w-left-top.svg"
                  className="f-18x48-9w-left-top"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <div className="d-flex">
                  <div className="image-bottom-left">
                    <div className="d-flex">
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 1);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 2);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 3);
                        }}
                      />
                    </div>
                    <div className="d-flex">
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 4);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 5);
                        }}
                      />
                      <ImageUpload
                        defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom.svg"
                        className="f-18x48-9w-small-bottom img-16-24"
                        onChange={(e) => {
                          handleImageChange(e, 6);
                        }}
                      />
                    </div>
                  </div>
                  <div className="image-bottom-right">
                    <ImageUpload
                      defaultImage="assets/img/breadcrumb/f-18x48-9w-small-bottom-f.svg"
                      className="f-18x48-9w-small-bottom-f"
                      onChange={(e) => {
                        handleImageChange(e, 7);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="frame-right">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-9w-big-str.svg"
                  className="f-18x48-9w-big-str"
                  onChange={(e) => {
                    handleImageChange(e, 8);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>72"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block21 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-31 images-12-12 s-c-21 d-flex justify-content-center align-items-center">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 1);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-center.svg"
                  className="f-18x48-3w-l-center image-three"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-3w-l-one.svg"
                  className="f-18x48-3w-l-one img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 4);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>72"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block22 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(7).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return ( 
      <div
        className="large-bg collage-29 images-12-12 s-c-22 d-flex justify-content-center align-items-center"
        style={{ display: "block" }}
      >
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 0);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 1);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 2);
                    }}
                  />
                </div>
                <div className="d-flex">
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 3);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 4);
                    }}
                  />
                  <ImageUpload
                    defaultImage="assets/img/breadcrumb/f-18x48-7w-1.svg"
                    className="f-18x48-7w-1 img-16-24"
                    onChange={(e) => {
                      handleImageChange(e, 5);
                    }}
                  />
                </div>
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-18x48-7w-2.svg"
                  className="f-18x48-3w-l-center last-seven-collage"
                  onChange={(e) => {
                    handleImageChange(e, 6);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>72"</span> */}
          </div>
        </div>
      </div> 
  );
};

const Block23 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    console.log(selectedImages);
    console.log(imagePreview);
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <>
      <div className="large-bg collage-32 images-12-12 s-c-23 d-flex justify-content-center align-items-center">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>24"</span> */}
            </div>
            <div id="captureArea">
            <div className="d-flex storyOutline">
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x72-5w2-2.svg"
                  className="f-24x72-5w2-2 img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 0);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x72-5w2-2.svg"
                  className="f-24x72-5w2-2 img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 1);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x72-5w2-2.svg"
                  className="f-24x72-5w2-2 img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                />
              </div>
              <div className="frame-left">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x72-5w2-33.svg"
                  className="f-24x72-5w2-33 img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/f-24x72-5w2-33.svg"
                  className="f-24x72-5w2-33 img-16-24"
                  onChange={(e) => {
                    handleImageChange(e, 4);
                  }}
                />
              </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>72"</span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Default = () => {
  return (
    <div className="frame-container">
      <img
        src="assets/img/blog/thumb.png"
        alt=""
        style={{ objectFit: "contain", maxWidth: "100%" }}
      />
    </div>
  );
};

export default function CustomBlocksStoryCanvas({
  selectedSize,
  addToCartTriggered,
  sendAllSelectedImages,
  sendblobImage,
}) {
  const updateAllSelectedImages = (images) => {
    sendAllSelectedImages(images);
  };

  const SendBlobImage = (images) => {
    sendblobImage(images);
  };

  return (
    <>
      {selectedSize?.size === "4-images 12×12" ? (
        <Block1
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "6-images 20×20" ? (
        <Block2
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "9-images 20×20" ? (
        <Block3
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "4-images 16×24" ? (
        <Block4
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "3-images 16×24" ? (
        <Block5
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "6-images 16×24" ? (
        <Block6
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "8-images 16×24" ? (
        <Block7
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-images 24×36" ? (
        <Block8
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "13-images 24×36" ? (
        <Block9
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "8-images 24×36" ? (
        <Block10
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "18-images 24×36" ? (
        <Block11
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "4-images 36×36" ? (
        <Block12
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-images 36×36" ? (
        <Block13
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "13-images 36×36" ? (
        <Block14
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "16-images 36×36" ? (
        <Block15
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "9-images 18×48" ? (
        <Block16
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "3-images 18×48" ? (
        <Block17
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-images 18×48" ? (
        <Block18
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "7-images 18×48" ? (
        <Block19
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "9-images 24×72" ? (
        <Block20
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-images 24×72" && selectedSize?.id === 24 ? (
        <Block21
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "7-images 24×72" ? (
        <Block22
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-images 24×72" && selectedSize?.id === 33 ? (
        <Block23
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : (
        <Default />
      )}
    </>
  );
}
